const accordions = document.querySelectorAll("button.accordion");

accordions.forEach((accordion) => {
  accordion.addEventListener("click", function () {
    const panel = this.nextElementSibling;
    if (!panel || !(panel instanceof HTMLElement)) return;

    this.classList.toggle("active");

    if (this.classList.contains("active")) {
      panel.style.maxHeight = `${panel.scrollHeight}px`;
    } else {
      panel.style.maxHeight = null;
    }

    accordions.forEach((acc) => {
      if (acc === this) return;
      acc.classList.remove("active");

      const otherPanel = acc.nextElementSibling;
      if (otherPanel && otherPanel instanceof HTMLElement) {
        otherPanel.style.maxHeight = null;
      }
    });
  });
});